import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-449087c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "page-alerts"
}
const _hoisted_3 = { class: "__allAlerts" }
const _hoisted_4 = { class: "check-box" }
const _hoisted_5 = { class: "image-container" }
const _hoisted_6 = { class: "alert-info" }
const _hoisted_7 = ["label"]
const _hoisted_8 = {
  key: 0,
  class: "item-name"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Fecha y hora: ", -1))
const _hoisted_10 = {
  key: 0,
  class: "item-name"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Punto de monitorización: ", -1))
const _hoisted_12 = { class: "item-condition" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Condición: ", -1))
const _hoisted_14 = {
  key: 3,
  class: "item-name"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Estimación: ", -1))
const _hoisted_16 = ["title"]
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Ver histórico ")
const _hoisted_18 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_alert_image_component = _resolveComponent("alert-image-component")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.hasData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_el_alert, {
            title: _ctx.$t('warning.notNotifications'),
            type: "info",
            "show-icon": ""
          }, null, 8, ["title"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: "common-layout"
              }, [
                _createVNode(_component_el_card, {
                  id: item.id,
                  class: "dynamic-card"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, { gutter: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 1 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createVNode(_component_el_checkbox, {
                                "model-value": _ctx.isSelected(item.id),
                                onChange: ($event: any) => (_ctx.handleCheckboxChange(item))
                              }, null, 8, ["model-value", "onChange"])
                            ])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              (item.id !== undefined)
                                ? (_openBlock(), _createBlock(_component_alert_image_component, {
                                    key: 0,
                                    id: item.id
                                  }, null, 8, ["id"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_col, { span: 11 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("div", {
                                class: "item-name",
                                label: item.name
                              }, [
                                _createElementVNode("b", null, _toDisplayString(item.name), 1)
                              ], 8, _hoisted_7),
                              (item.dateTime)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _hoisted_9,
                                    _createTextVNode(_toDisplayString(_ctx.getDate(item.dateTime)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (item.alert?.parameterAlerts)
                                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                    key: 1,
                                    class: "item-tooltip",
                                    effect: "dark",
                                    content: item.alert?.parameterAlerts[0].samplingPoint?.name,
                                    placement: "top"
                                  }, {
                                    default: _withCtx(() => [
                                      (item.alert?.parameterAlerts[0].samplingPoint?.name)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                            _hoisted_11,
                                            _createTextVNode(" " + _toDisplayString(item.alert?.parameterAlerts[0].samplingPoint?.name), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1032, ["content"]))
                                : _createCommentVNode("", true),
                              (item.alert?.parameterAlerts)
                                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                    key: 2,
                                    class: "item-tooltip",
                                    effect: "dark",
                                    content: _ctx.getCondition(item.alert?.parameterAlerts),
                                    placement: "top"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_12, [
                                        _hoisted_13,
                                        _createTextVNode(" " + _toDisplayString(_ctx.getCondition(item.alert?.parameterAlerts)), 1)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["content"]))
                                : _createCommentVNode("", true),
                              (item.alert?.parameterAlerts && item.id)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _hoisted_15,
                                    _createTextVNode(" " + _toDisplayString(_ctx.alertEstimations[item.id] || "-"), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_row, {
                              gutter: 10,
                              justify: "end",
                              class: "button-row"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, { span: 2 }, {
                                  default: _withCtx(() => [
                                    (_ctx.typeAlert === 'samplingPoint' && item.alert)
                                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                          key: 0,
                                          content: item.alert?.active ? 'Desactivar alerta' : 'Activar alerta',
                                          placement: "top"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", null, [
                                              (_ctx.typeAlert === 'samplingPoint' && item.alert)
                                                ? (_openBlock(), _createBlock(_component_el_switch, {
                                                    key: 0,
                                                    modelValue: item.alert.active,
                                                    "onUpdate:modelValue": ($event: any) => ((item.alert.active) = $event),
                                                    class: "switch",
                                                    onClick: ($event: any) => (_ctx.deactivateAlert(item))
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["content"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_col, { span: 4 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_button, {
                                      type: "primary",
                                      onClick: ($event: any) => (_ctx.deleteAlert(item)),
                                      class: "delete-btn",
                                      style: {"width":"100%"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("em", {
                                          class: "el-icon el-icon-trash fas",
                                          title: _ctx.$t('btn.delete')
                                        }, null, 8, _hoisted_16)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_col, { span: 4 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_button, {
                                      type: "primary",
                                      onClick: ($event: any) => (_ctx.viewHistory(item.id)),
                                      class: "delete-btn",
                                      style: {"width":"100%"}
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_17
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["id"])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_el_pagination, {
              class: "app-table",
              layout: "total, sizes, prev, pager, next, jumper",
              currentPage: _ctx.currentPage,
              "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
              "page-sizes": [10, 20, 50, 100],
              "page-size": _ctx.rowPerPage,
              total: _ctx.totalRows,
              onSizeChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePaginationSize($event))),
              onCurrentChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePaginationPage($event)))
            }, null, 8, ["currentPage", "page-size", "total"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}